import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    organization: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Tutaj dodałbyś logikę wysyłania formularza
    console.log('Form submitted:', formData);
    alert('Dziękujemy za wiadomość! Skontaktujemy się z Państwem w ciągu 24 godzin.');
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <div className="section-subtitle">Kontakt</div>
          <h2>Rozpocznijmy Współpracę</h2>
          <p>
            Masz pytania lub chcesz omówić swój projekt? Skontaktuj się z nami 
            już dziś i otrzymaj bezpłatną konsultację.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Dane Kontaktowe</h3>
            
            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div>
                <strong>Email</strong><br />
                <a href="mailto:kontakt@grantpro.pl">kontakt@jasnegranty.pl</a>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-phone"></i>
              </div>
              <div>
                <strong>Telefon</strong><br />
                <a href="tel:+48123456789">+48 123 456 789</a>
              </div>
            </div>

            {/* <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div>
                <strong>Adres</strong><br />
                ul. Przykładowa 1<br />
                00-001 Warszawa
              </div>
            </div> */}

            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-clock"></i>
              </div>
              <div>
                <strong>Godziny pracy</strong><br />
                Pn-Pt: 9:00 - 18:00<br />
                Sb: 10:00 - 14:00
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <h3>Wyślij Wiadomość</h3>
            
            <div className="form-group">
              <label htmlFor="name">Imię i nazwisko *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                aria-describedby="name-help"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Adres email *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                aria-describedby="email-help"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Telefon</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                aria-describedby="phone-help"
              />
            </div>

            <div className="form-group">
              <label htmlFor="organization">Organizacja/Firma</label>
              <input
                type="text"
                id="organization"
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                aria-describedby="organization-help"
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Wiadomość *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                placeholder="Opisz swój projekt lub zadaj pytanie..."
                aria-describedby="message-help"
              />
            </div>

            <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
              <i className="fas fa-paper-plane"></i>
              Wyślij wiadomość
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
